/* Record, on every mention in a piece of AI-authored suggestion HTML, that its
 * visible label was written by that author.
 *
 * An AI skill cites its source as the anchor's own text — the source and the
 * date the finding was recorded ("Braden, 2026-07-22") — and that date is why
 * the citation exists, so it has to reach the screen verbatim. The @-picker
 * writes its label into the same place (MentionNode's `display` parses from
 * text content), but the picker's label is a copy of the live resource the chip
 * re-derives on every render, so honouring it would freeze a value that is
 * otherwise fresh. Nothing in the stored string distinguishes the two; the
 * author does, and this is the moment the author is known.
 *
 * Applied where a resolved AI operation's content HTML is produced, so the
 * label is on the node before it reaches any consumer — the preview, the
 * island's seed, and the accept's insert all parse the same marked HTML, and
 * MentionNode's `authoredLabel` attr carries it from there into the saved note.
 * Content this pipeline builds from nodes ALREADY in the document (a task item
 * being checked, a choice being set) is deliberately not routed through here:
 * the mentions inside it are the clinician's, and marking them would freeze the
 * chips this exists to keep live.
 */
export function withAuthoredMentionLabels(html: string): string {
  if (!html.includes('mention')) {
    return html
  }
  const container = document.createElement('div')
  container.innerHTML = html
  let marked = false
  // forEach, not for…of: the workspace lib set is DOM without DOM.Iterable, so
  // a NodeList is not iterable here.
  container.querySelectorAll('a[data-type="mention"]').forEach((anchor) => {
    const label = anchor.textContent
    if (!label) {
      return
    }
    anchor.setAttribute('data-authored-label', label)
    marked = true
  })
  return marked ? container.innerHTML : html
}
